// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3sE6q","title":"ClientCherryInfo_title__3IEaa","itemText":"ClientCherryInfo_itemText__1vhnb"};